import { render, staticRenderFns } from "./testPaperDetails.vue?vue&type=template&id=160e7903&scoped=true"
import script from "./testPaperDetails.vue?vue&type=script&lang=js"
export * from "./testPaperDetails.vue?vue&type=script&lang=js"
import style0 from "../asset/css/testPaperDetails.scss?vue&type=style&index=0&id=160e7903&prod&lang=scss&scoped=true&external"
import style1 from "./testPaperDetails.vue?vue&type=style&index=1&id=160e7903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e7903",
  null
  
)

export default component.exports